import { Box, Button, CircularProgress, Grid2, Modal, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { viewPDF } from "../../../utils/viewPDF";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import ErrorModal from "../../../utils/ErrorModal";
import { handleExportPDF } from "../../../utils/exportToPDF";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const Preview = ({ tender, setStep, bid, data, user, fileNames }) => {
  const navigate = useNavigate();
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const {tenderId} = useParams()
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [draft, setDraft] = useState()
  const pdfRef = useRef();
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
      const getDraft = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/draft-bid?vendorId=${vendorId}&tenderId=${tenderId}`,
            { headers: { Authorization: `Bearer ${user.accessToken}` } }
          );
          setDraft(res.data);
        } catch (error) {
          console.log(error);
        }
      };
  
      getDraft();
    }, []);

  const groupedWorkItems = data?.reduce((acc, item) => {
    if (!acc[item.section]) {
      acc[item.section] = [];
    }
    acc[item.section].push(item);
    return acc;
  }, {});

  const handleNext = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/bid`,
        {
          vendorId: vendorId,
          tenderId: tender.tenderId,
          ts1: bid.ts1,
          ts2: bid.ts2,
          ts3: bid.ts3,
          ts4: bid.ts4,
          ts5: bid.ts5,
          ts6: bid.ts6,
          ts7: bid.ts7,
          ts8: bid.ts8,
          ts1Filename: fileNames.ts1,
          ts2Filename: fileNames.ts2,
          ts3Filename: fileNames.ts3,
          ts4Filename: fileNames.ts4,
          ts5Filename: fileNames.ts5,
          ts6Filename: fileNames.ts6,
          ts7Filename: fileNames.ts7,
          ts8Filename: fileNames.ts8,
          bidWorkItems: data,
        },
        { headers: { Authorization: `Bearer ${user.accessToken}` } }
      );
      // await axios.delete(
      //   `${process.env.REACT_APP_BACKEND_URL}/draft-bid?draftBidId=${draft.draftBidId}`,
      //   { headers: { Authorization: `Bearer ${user.accessToken}` } }
      // );
      navigate("/vendor/dashboard");
    } catch (error) {
      setOpenError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    setStep((prev) => prev - 1);
  };
  return (
    <div style={{ position: "relative" }}>
      {exporting && <div className="uploading-div">Exporting PDF, this may take a while. <CircularProgress color="#fff" /></div>}
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button
          className="btn-contained"
          sx={{ width: "200px" }}
          onClick={async () => {
            try {
              setExporting(true)
              await handleExportPDF(pdfRef, "Bid_Submission")
            } catch (error) {
              console.log(error)
            } finally {
              setExporting(false)
            }
          }}
        >
          Export PDF
        </Button>
      </div>
      {loading && <div className="laoding-div uploading-div">Submitting Bid... <CircularProgress color="#fff" /></div>}
      <h2>Bid Submission Preview</h2>
      <div ref={pdfRef}>
        <Box className="dashboard-container" px={10}>
          <Typography className="form-title">Technical Specifications</Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              TS-1 {tender && tender.ts1Title && <span>({tender.ts1Title})</span>}
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {bid && bid.ts1 && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(bid.ts1, user)}
                >
                  {fileNames.ts1}
                </Button>
              )}
            </Grid2>
            {tender && tender.ts2 && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  TS-2{" "}
                  {tender && tender.ts2Title && <span>({tender.ts2Title})</span>}
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {bid && bid.ts2 && (
                    <Button
                      sx={{
                        margin: "0 !important",
                        padding: "0 !important",
                        width: "max-content !important",
                        fontSize: "12px !important",
                        textDecoration: "underline",
                        textAlign: "start",
                      }}
                      onClick={() => viewPDF(bid.ts2, user)}
                    >
                      {fileNames.ts2}
                    </Button>
                  )}
                </Grid2>
              </>
            )}
            {tender && tender.ts3 && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  TS-3{" "}
                  {tender && tender.ts3Title && <span>({tender.ts3Title})</span>}
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {bid && bid.ts3 && (
                    <Button
                      sx={{
                        margin: "0 !important",
                        padding: "0 !important",
                        width: "max-content !important",
                        fontSize: "12px !important",
                        textDecoration: "underline",
                        textAlign: "start",
                      }}
                      onClick={() => viewPDF(bid.ts3, user)}
                    >
                      {fileNames.ts3}
                    </Button>
                  )}
                </Grid2>
              </>
            )}
            {tender && tender.ts4 && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  TS-4{" "}
                  {tender && tender.ts4Title && <span>({tender.ts4Title})</span>}
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {bid && bid.ts4 && (
                    <Button
                      sx={{
                        margin: "0 !important",
                        padding: "0 !important",
                        width: "max-content !important",
                        fontSize: "12px !important",
                        textDecoration: "underline",
                        textAlign: "start",
                      }}
                      onClick={() => viewPDF(bid.ts4, user)}
                    >
                      {fileNames.ts4}
                    </Button>
                  )}
                </Grid2>
              </>
            )}
            {tender && tender.ts5 && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  TS-5{" "}
                  {tender && tender.ts5Title && <span>({tender.ts5Title})</span>}
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {bid && bid.ts5 && (
                    <Button
                      sx={{
                        margin: "0 !important",
                        padding: "0 !important",
                        width: "max-content !important",
                        fontSize: "12px !important",
                        textDecoration: "underline",
                        textAlign: "start",
                      }}
                      onClick={() => viewPDF(bid.ts5, user)}
                    >
                      {fileNames.ts5}
                    </Button>
                  )}
                </Grid2>
              </>
            )}
            {tender && tender.ts6 && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  TS-6{" "}
                  {tender && tender.ts6Title && <span>({tender.ts6Title})</span>}
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {bid && bid.ts6 && (
                    <Button
                      sx={{
                        margin: "0 !important",
                        padding: "0 !important",
                        width: "max-content !important",
                        fontSize: "12px !important",
                        textDecoration: "underline",
                        textAlign: "start",
                      }}
                      onClick={() => viewPDF(bid.ts6, user)}
                    >
                      {fileNames.ts6}
                    </Button>
                  )}
                </Grid2>
              </>
            )}
            {tender && tender.ts7 && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  TS-7{" "}
                  {tender && tender.ts7Title && <span>({tender.ts7Title})</span>}
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {bid && bid.ts7 && (
                    <Button
                      sx={{
                        margin: "0 !important",
                        padding: "0 !important",
                        width: "max-content !important",
                        fontSize: "12px !important",
                        textDecoration: "underline",
                        textAlign: "start",
                      }}
                      onClick={() => viewPDF(bid.ts7, user)}
                    >
                      {fileNames.ts7}
                    </Button>
                  )}
                </Grid2>
              </>
            )}
            {tender && tender.ts8 && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  TS-8{" "}
                  {tender && tender.ts8Title && <span>({tender.ts8Title})</span>}
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {bid && bid.ts8 && (
                    <Button
                      sx={{
                        margin: "0 !important",
                        padding: "0 !important",
                        width: "max-content !important",
                        fontSize: "12px !important",
                        textDecoration: "underline",
                        textAlign: "start",
                      }}
                      onClick={() => viewPDF(bid.ts8, user)}
                    >
                      {fileNames.ts8}
                    </Button>
                  )}
                </Grid2>
              </>
            )}
          </Grid2>
        </Box>
        <Box className="dashboard-container" px={10}>
          <Typography className="form-title">Work Item Details</Typography>
          <table
            border={1}
            style={{
              borderCollapse: "collapse",
              width: "100%",
              marginTop: "10px",
            }}
          >
            <thead>
              <tr>
                <th style={{ padding: "20px" }}>Item Name</th>
                <th>Description</th>
                <th>Section</th>
                <th>Unit</th>
                <th>Quantity</th>
                <th>Rate (in &#8377;)</th>
                <th>Total (in &#8377;)</th>
              </tr>
            </thead>
            <tbody>
              {groupedWorkItems &&
                Object.entries(groupedWorkItems).map(
                  ([section, items], sectionIndex) => {
                    const sectionTotal = items
                      .reduce((acc, item) => acc + parseFloat((item.quantity * item.rate) || 0), 0)
                      .toFixed(2);
                    return (
                      <React.Fragment key={sectionIndex}>
                        <tr
                          style={{
                            backgroundColor: "#d9edf7",
                            fontWeight: "bold",
                          }}
                        >
                          <td
                            colSpan={6}
                            style={{ textAlign: "left", padding: "10px" }}
                          >
                            {section}
                          </td>
                          <td style={{ textAlign: "center", padding: "10px" }}>
                            {sectionTotal &&
                              new Intl.NumberFormat("en-IN", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(sectionTotal)}
                          </td>
                        </tr>
                        {items.map((item, index) => (
                          <tr key={index} style={{ textAlign: "center" }}>
                            <td style={{ padding: "20px" }}>{item.itemName}</td>
                            <td>{item.description}</td>
                            <td>{item.section}</td>
                            <td>{item.unit}</td>
                            <td>{item.quantity}</td>
                            <td>
                              {new Intl.NumberFormat("en-IN", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(item.rate)}
                            </td>
                            <td>
                              {new Intl.NumberFormat("en-IN", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(parseFloat(item.rate || 0) *
                              parseFloat(item.quantity || 0))}
                            </td>
                          </tr>
                        ))}
                      </React.Fragment>
                    );
                  }
                )}
              <tr style={{ fontWeight: "bold", backgroundColor: "#d9edf7" }}>
                <td colSpan={6} style={{ textAlign: "right", padding: "8px" }}>
                  Grand Total (in &#8377;):
                </td>
                <td style={{ textAlign: "center" }}>
                  {new Intl.NumberFormat("en-IN", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(
                    Object.values(groupedWorkItems)
                      .flat()
                      .reduce(
                        (acc, item) => acc + (parseFloat(item.quantity * item.rate) || 0),
                        0
                      )
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </Box>
      </div>

      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button className="btn-contained" onClick={() => setOpen(true)}>
          Submit
        </Button>
      </Box>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to submit these details?
          </Typography>
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button
              className="btn-outlined"
              variant="outlined"
              onClick={() => setOpen(false)}
            >
              No
            </Button>
            <Button
              className="btn-contained"
              onClick={handleNext}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Yes"}
            </Button>
          </Box>
        </Box>
      </Modal>
      <ErrorModal
        open={openError}
        handleClose={() => setOpenError(false)}
        msg={"Internal Server Error. Please try again."}
      />
    </div>
  );
};

export default Preview;
